import { render, staticRenderFns } from "./WorkShiftsTable.vue?vue&type=template&id=8024317e&"
import script from "./WorkShiftsTable.vue?vue&type=script&lang=js&"
export * from "./WorkShiftsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports